<template>
  <div class="form__wrapper">
    <form
      ref="form"
      :data-theme="theme"
      role="form"
      aria-label="Contact Form"
      novalidate="novalidate"
      method="post"
      class="c-template c-template--form"
      @submit.prevent="sendForm"
      :class="[status ? 'c-template--hidden' : false]"
    >
      <slot
        v-for="slot in slots"
        :name="slot"
      />
    </form>

    <transition name="fade">
      <FormThanks
        :name="name"
        v-if="status"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import FormThanks from '@/components/Form/FormExtra/FormThanks.vue';

export default {
  name: 'FormCore',

  components: {
    FormThanks,
  },

  props: {
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    slots: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      name: '',
      status: false,
      state: false,
    };
  },

  computed: {
    ...mapGetters({
      formStatus: 'getFormStatus',
    }),
  },

  watch: {
    formStatus(n) {
      if (n === 'sent') {
        this.state = 'sent';
        this.status = true;
      } else if (n === 'sending') {
        this.state = 'sending';
        this.status = false;
      } else {
        this.state = false;
        this.status = false;
      }
    },
  },

  mounted() {
    this.$store.commit('FORM_STATUS', null);
  },

  methods: {
    sendForm() {
      const validation = this.checkValidate();

      if (validation) {
        this.$store.commit('FORM_STATUS', 'sending');
        const formData = new FormData(this.$refs.form);

        const form = [];

        for (let value of formData.values()) { // eslint-disable-line
          form.push(value);
        }

        this.name = formData.get('fname');

        this.$store.dispatch('SEND_FORM', form);
      }
    },

    checkValidate() {
      let status = true;
      const inputs = [];
      this.$children.forEach((child) => {
        inputs.push(...child.$children);
      });

      inputs.forEach((input) => {
        if (input.type === 'submit') return;
        const check = input.checkValue();
        if (check === 'invalid') status = false;
      });

      return status;
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  display: flex;
  flex-flow: row wrap;

  .form__row {
    min-width: 0;

    & > .form__group {
      margin: 0 0 40px 0;

      &--thanks {
        margin: 0 0 20px 0;
      }

      @include mq(ipadP) {
        margin: 0;

        &--thanks {
          margin: 0;
        }
      }
    }

    @include mq(ipadP) {
      padding: 20px 0;

      &--thanks {
        padding: 10px 0;
      }
    }
  }

  .form__row, .form__group {
    position: relative;
    display: flex;
    flex: 0 0 100%;
    flex-flow: row wrap;

    justify-content: space-between;
    align-items: baseline;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s cubic-bezier(.165,.84,.44,1) 0.7s,
    transform 0.5s cubic-bezier(.165,.84,.44,1) 0.7s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translate3d(0%, 100%, 0%);
}

a {
  text-decoration: none;
  color: inherit;
  display: inline-block;
  margin-left: 2px;

  @at-root [data-theme="default"] & {
    bdi {
      position: relative;
      display: inline-block;
      vertical-align: top;
      color: $color-input;
      padding: 0 0 12px 0;
      overflow: hidden;

      &::before,
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;

        background: $color-label;
      }

      &::before {
        transform: translate3d(0%, 0, 0);
        opacity: 1;
        transition: transform 0.4s cubic-bezier(.165,.84,.44,1);
      }

      &::after {
        transform: translate3d(-102%, 0, 0);
        opacity: 0;
      }
    }

    &:hover {
      bdi {
        &::before {
          transform: translate3d(102%, 0, 0);
          opacity: 1;
        }

        &::after {
          transition: transform 0.4s cubic-bezier(.165,.84,.44,1);
          transition-delay: 0.3s;
          transform: translate3d(0%, 0, 0);
          opacity: 1;
        }
      }
    }
  }
}

.c-template--hidden {
  transition: all 0.5s ease-out;
  opacity: 0;
  visibility: hidden;
}
</style>
